(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["varela-shipping-strip"] && !Shopify.designMode) return;
  try {
    (function () {
  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  document.querySelectorAll('.vb-ship-views').forEach(function (el) {
    if (el.dataset.vbInit) return;
    el.dataset.vbInit = '1';
    var min = parseInt(el.dataset.min, 10) || 30;
    var max = parseInt(el.dataset.max, 10) || 70;
    if (max < min) { var t = min; min = max; max = t; }
    var nEl = el.querySelector('.vb-ship-views__n');
    var labelEl = el.querySelector('.vb-ship-views__label');
    if (labelEl) labelEl.textContent = el.dataset.text || 'personas viendo esto ahora';
    var current = rand(min, max);
    if (nEl) nEl.textContent = current;
    setInterval(function () {
      current += rand(-2, 2);
      if (current < min) current = min + rand(0, 2);
      if (current > max) current = max - rand(0, 2);
      if (nEl) nEl.textContent = current;
    }, 4000);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["varela-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }

  document.querySelectorAll('.vb-urg-views').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 8;
    var max = parseInt(el.dataset.max, 10) || 24;
    if (max < min) { var t = min; min = max; max = t; }

    var nEl = el.querySelector('.vb-urg-views__n');
    var labelEl = el.querySelector('.vb-urg-views__label');
    if (labelEl) labelEl.textContent = el.dataset.text || 'personas viendo esto ahora';

    var current = rand(min, max);
    if (nEl) nEl.textContent = current;

    setInterval(function () {
      current += rand(-2, 2);
      if (current < min) current = min + rand(0, 2);
      if (current > max) current = max - rand(0, 2);
      if (nEl) nEl.textContent = current;
    }, 4000);
  });

  // Stock real por talla (solo se muestra cuando es verdad: 0 < stock <= umbral)
  document.querySelectorAll('.vb-urg--stock').forEach(function (el) {
    var map = {};
    try { map = JSON.parse(el.dataset.vbStock || '{}'); } catch (e) { return; }
    var threshold = parseInt(el.dataset.threshold, 10) || 5;
    var tpl = el.dataset.text || '🔥 ¡Solo quedan {n} en tu talla!';
    var textEl = el.querySelector('.vb-urg-text');
    var root = el.closest('.shopify-section, product-information, [id^="MainProduct"]') || document;

    function currentId() {
      var input = root.querySelector('[name="id"]') || document.querySelector('product-form [name="id"], form[action*="/cart/add"] [name="id"], [name="id"]');
      return input ? String(input.value) : null;
    }

    function render() {
      var id = currentId();
      var qty = id && Object.prototype.hasOwnProperty.call(map, id) ? map[id] : null;
      if (qty !== null && qty > 0 && qty <= threshold) {
        if (textEl) textEl.textContent = tpl.replace('{n}', qty);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    render();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest && e.target.closest('product-form, form[action*="/cart/add"], variant-picker, .product-form'))) {
        setTimeout(render, 60);
      }
    }, true);
    var last = currentId();
    setInterval(function () {
      var now = currentId();
      if (now !== last) { last = now; render(); }
    }, 700);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vb-trust-badges"] && !Shopify.designMode) return;
  try {
    // Fila «¿Primer pedido?» (13/10/2026): solo si existe la ventana propia de la lista VIP y la clienta no se ha apuntado ya
  (function () {
    function pinta() {
      var filas = document.querySelectorAll('[data-vb-tb-vip]'); if (!filas.length) return;
      var suscrita = false; try { suscrita = localStorage.getItem('vb-vip-suscrita') === '1'; } catch (e) {}
      filas.forEach(function (f) {
        if (suscrita || typeof window.vbVipAbrir !== 'function') { f.remove(); return; }
        f.hidden = false;
        if (!f.dataset.vbListo) { f.dataset.vbListo = '1'; f.addEventListener('click', function () { window.vbVipAbrir(); }); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinta); else pinta();
    window.addEventListener('load', pinta);
  })();
  } catch(e) { console.error(e); }
})();

})();
